export default "__VITE_ASSET__BmsjdMsH__"